import { Chip, List, ListItem, listItemClasses, styled } from '@mui/material';
import {
    DateRange,
    PickersShortcutsProps,
    useIsValidValue,
    usePickerContext
} from '@mui/x-date-pickers-pro';

export default function CustomRangeShortcuts(props: PickersShortcutsProps<DateRange<Date>>) {
    const { items, ...rest } = props;
    const isValid = useIsValidValue<DateRange<Date>>();
    const { setValue } = usePickerContext<DateRange<Date>>();

    if (items == null || items.length === 0) {
        return null;
    }

    const resolvedItems = items.map((item) => {
        const newValue = item.getValue({ isValid });

        return {
            label: item.label,
            onClick: () => {
                setValue(newValue, { ...rest, shortcut: item });
            },
            disabled: !isValid(newValue)
        };
    });

    return (
        <Root dense>
            { resolvedItems.map((item) => {
                return (
                    <ListItem key={ item.label }>
                        <Chip { ...item } />
                    </ListItem>
                );
            }) }
        </Root>
    );
}

const Root = styled(List)(({ theme }) => ({
    display: 'flex',
    padding: theme.spacing(0, 4),

    [`.${ listItemClasses.root }`]: {
        padding: theme.spacing(0, 1, 0, 0)
    }
}));
